import { CSSObject } from '@emotion/core';

export const containerStyles: CSSObject = {
    marginBottom: '16px',
};

export const titleStyles: CSSObject = {
    marginBottom: '8px',
};
